import { render, staticRenderFns } from "./ContractServiceFee.yaml?vue&type=template&id=2fd07d46&component"
import script from "./ContractServiceFee.yaml?vue&type=script&lang=ts&component"
export * from "./ContractServiceFee.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports